export default __webpack_public_path__ + "images/4f48253bbf751beda08b324d733be8b1.png";